import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import NewPortAuto from '../../components/EpikBoxes/NewPortAuto';

const RearrangePorts = ({ obis, newObiArrangement, modifyEPIS }) => {
  const [newSeries, setNewSeries] = useState([]);

  const handleCurrentSeries = useMemo(() => {
    return obis.map((_, index) => {
      return { sequence: `${index + 1}` };
    });
  }, [obis]);

  const onOptionSelect = (suggest, index) => {
    if (suggest?.sequence) {
      const obj = { currentPort: index, newPort: suggest?.sequence - 1 };
      setNewSeries([...newSeries, obj]);
    } else {
      const filteredSeries = newSeries.filter(item => item.currentPort !== index);
      setNewSeries(filteredSeries);
    }
  };

  useEffect(() => {
    newObiArrangement(newSeries);
  }, [newSeries]);

  return (
    <Row>
      <Col className="d-flex flex-column align-items-center justify-content-center" md={4}>
        <h1>Current EPI Position</h1>
        <div className="p-2">
          {handleCurrentSeries?.map(item => {
            return (
              <div className="p-2">
                <h1>{item.sequence}</h1>
              </div>
            );
          })}
        </div>
      </Col>
      <Col className="d-flex flex-column align-items-center justify-content-center" md={4}>
        <h1>MAC Address</h1>
        <div className="p-2">
          {obis?.map(item => {
            return (
              <div className="p-2">
                <h1>{item.macAddress}</h1>
              </div>
            );
          })}
        </div>
      </Col>
      <Col className="d-flex flex-column align-items-center justify-content-center" md={4}>
        <h1>New EPI Position</h1>
        <div className="p-2">
          {handleCurrentSeries?.map((item, index) => {
            return (
              <div className="pb-2">
                <NewPortAuto
                  dropdownList={handleCurrentSeries}
                  dropdownValue="sequence"
                  onChange={({ suggestion }) => onOptionSelect(suggestion, index)}
                  placeholder="Select Number"
                  disabledSeries={newSeries}
                  isDisabled={modifyEPIS === 'read'}
                />
              </div>
            );
          })}
        </div>
      </Col>
    </Row>
  );
};

export default RearrangePorts;
